/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FinopsAssessmentTriggerStatusResponse {
    getFixupPrototypeFunction() { return FinopsAssessmentTriggerStatusResponse.fixupPrototype; }

    static newInstance(model: Partial<FinopsAssessmentTriggerStatusResponse>): FinopsAssessmentTriggerStatusResponse {
        let obj = Object.assign(new FinopsAssessmentTriggerStatusResponse(), model);
        FinopsAssessmentTriggerStatusResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FinopsAssessmentTriggerStatusResponse>): FinopsAssessmentTriggerStatusResponse {
        if (!model) return null;
        return FinopsAssessmentTriggerStatusResponse.newInstance(<FinopsAssessmentTriggerStatusResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FinopsAssessmentTriggerStatusResponse) {
        if (!obj) return;

        models.FinopsAssessmentTriggerStatusResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FinopsAssessmentTriggerStatusResponse): boolean {
        Object.setPrototypeOf(obj, FinopsAssessmentTriggerStatusResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Assessment run id status
     */
    status: models.AssessmentRunStatus;

    /**
     * Assessment run id status message
     */
    status_message: string;

}
